/* istanbul ignore file */
import { readFromStorage, clearAll } from './get-location/location-from-storage';
import { publishEvent, publishEventAtUrl, languageForApi } from './network';
import { getLocationCoordinates } from './get-location';
import lodash from 'lodash';

export const fireSurveyResultEvent = async (language, riskResult, workflowResponses, essEventData) => {
  const eventName = 'symptom_inference';
  const eventData = {
    language: languageForApi(language),
    question_id: 'covid_19_risk',
    question_text: 'covid_19_risk',
    response_id: lodash.get(riskResult, "meta_data.analytics_data.risk_id"),
    response_text: lodash.get(riskResult, "meta_data.analytics_data.risk_display_category"),
    risk_name: lodash.get(riskResult, "meta_data.analytics_data.risk_name"),
    action_category: lodash.get(riskResult, "meta_data.action_category"),
    workflow_responses: workflowResponses,
    ...essEventData
  };

  if (Object.keys(essEventData).length) {
    const {
      latitude, longitude
    } = readFromStorage();
    clearAll();
    return publishEvent(eventName, { ...eventData }, { latitude, longitude });
  }
  clearAll();
  return publishEvent(eventName, eventData, getLocationCoordinates());
};

export const fireSurveyResultEventAtUrl = async (language, riskResult, workflowResponses, eventUrl) => {
  const eventName = 'symptom_inference';
  let riskResultData = {};
  if (riskResult && riskResult.meta_data) {
    riskResultData = {
      response_id: riskResult.meta_data.analytics_data.risk_id,
      response_text: riskResult.meta_data.analytics_data.risk_display_category,
      risk_name: riskResult.meta_data.analytics_data.risk_name,
      action_category: riskResult.meta_data.action_category,
    }
  }
  const eventData = {
    language: languageForApi(language),
    question_id: 'covid_19_risk',
    question_text: 'covid_19_risk',
    ...riskResultData,
    workflow_responses: workflowResponses,
  };
  clearAll();
  return publishEventAtUrl(eventName, eventData, eventUrl);
};

export const firePageNavigationEvent = async page => publishEvent('page_navigation', {
  source_page: 'home_page',
  destination_page: page
}, getLocationCoordinates());

export const fireStatsScreenEvent = async (selectedState, language, selectedCountry) => {
  const eventData = {
    language: languageForApi(language),
    selected_state: selectedState,
    selected_country: selectedCountry
  };
  publishEvent('StatisticsScreen', eventData, getLocationCoordinates());
};

export const fireNoChangeEvent = async essData => {
  let location = getLocationCoordinates();
  if (!location.longitude) {
    location = {
      longitude: null, latitude: null
    };
  }
  publishEvent('symptom_inference_no_change', essData, location);
};

export const fireQuickSurveyWithNoChangeEvent = async (language, workflowResponses, essEventData) => {
  const eventName = 'symptom_inference_no_change';
  const eventData = {
    language: languageForApi(language),
    question_id: 'covid_19_risk',
    question_text: 'covid_19_risk',
    workflow_responses: workflowResponses,
    ...essEventData
  };

  if (Object.keys(essEventData).length) {
    const {
      latitude, longitude
    } = readFromStorage();
    clearAll();
    return publishEvent(eventName, { ...eventData }, { latitude, longitude });
  }
  clearAll();
  return publishEvent(eventName, eventData, getLocationCoordinates());
};


